<section class="sec" id="industry">
  <div class="wrap">
    <div class="sec-head" appReveal>
      <span class="kicker">Industry</span>
      <h2>Smart AI. Any Industry.</h2>
      <p>
        Customized real-time sales and support solutions for businesses of all
        sizes and industries — boosting engagement, optimizing operations, and
        accelerating growth.
      </p>
    </div>
    <div class="ind-grid">
      <a class="ind-card" appReveal [routerLink]="['/industry-smart-ai']">
        <div
          class="ind-icon"
          style="background: linear-gradient(135deg, #2347ff, #5a78ff)"
        >
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
            <path
              d="M12 2a3 3 0 013 3 3 3 0 013 3 3 3 0 010 6 3 3 0 01-3 3 3 3 0 01-6 0 3 3 0 01-3-3 3 3 0 010-6 3 3 0 013-3 3 3 0 013-3z"
              stroke="#fff"
              stroke-width="1.5"
            />
            <circle cx="12" cy="11" r="2" fill="#fff" />
          </svg>
        </div>
        <h3>
          Smart AI
          <span class="arrow"
            ><svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <path
                d="M5 12h14M13 6l6 6-6 6"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              /></svg
          ></span>
        </h3>
        <p>
          No matter your domain, ConnectNow enhances customer interactions with
          intelligent automation.
        </p>
        <ul class="ind-feats">
          <li>Instant lead capture</li>
          <li>Appointment scheduling</li>
          <li>Turn visitors into customers</li>
          <li>Industry-specific workflows</li>
        </ul>
      </a>
      <a class="ind-card" appReveal [routerLink]="['/industry-auto']">
        <div
          class="ind-icon"
          style="background: linear-gradient(135deg, #ff6b4a, #ff9472)"
        >
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
            <path
              d="M3 13l2-5a3 3 0 013-2h8a3 3 0 013 2l2 5v5h-3v-2H6v2H3v-5z"
              stroke="#fff"
              stroke-width="1.6"
              stroke-linejoin="round"
            />
            <circle cx="7" cy="16" r="1.3" fill="#fff" />
            <circle cx="17" cy="16" r="1.3" fill="#fff" />
          </svg>
        </div>
        <h3>
          Auto
          <span class="arrow"
            ><svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <path
                d="M5 12h14M13 6l6 6-6 6"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              /></svg
          ></span>
        </h3>
        <p>
          Buying a car or handling maintenance — ConnectNow AI is here to help.
          24/7 sales, powered by AI.
        </p>
        <ul class="ind-feats">
          <li>View your car from your living room</li>
          <li>Connect with a sales rep via video or call</li>
          <li>Schedule sales &amp; service visits</li>
        </ul>
      </a>
      <a class="ind-card" appReveal [routerLink]="['/industry-telecom']">
        <div
          class="ind-icon"
          style="background: linear-gradient(135deg, #10b98e, #46d6b0)"
        >
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
            <path
              d="M2 8a14 14 0 0120 0M5 12a9 9 0 0114 0M8 15.5a5 5 0 018 0"
              stroke="#fff"
              stroke-width="1.7"
              stroke-linecap="round"
            />
            <circle cx="12" cy="19" r="1.5" fill="#fff" />
          </svg>
        </div>
        <h3>
          Telecom
          <span class="arrow"
            ><svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <path
                d="M5 12h14M13 6l6 6-6 6"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              /></svg
          ></span>
        </h3>
        <p>Real-time sales support for your mobility and internet needs.</p>
        <ul class="ind-feats">
          <li>Mobile devices</li>
          <li>Broadband internet</li>
          <li>Wi-Fi</li>
          <li>Security</li>
        </ul>
      </a>
      <a class="ind-card" appReveal [routerLink]="['/industry-real-estate']">
        <div
          class="ind-icon"
          style="background: linear-gradient(135deg, #7c5cff, #a98bff)"
        >
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
            <path
              d="M4 11l8-6 8 6v9H4v-9z"
              stroke="#fff"
              stroke-width="1.6"
              stroke-linejoin="round"
            />
            <path d="M10 20v-5h4v5" stroke="#fff" stroke-width="1.6" />
          </svg>
        </div>
        <h3>
          Real-Estate
          <span class="arrow"
            ><svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <path
                d="M5 12h14M13 6l6 6-6 6"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              /></svg
          ></span>
        </h3>
        <p>A 24/7 personal concierge for home purchases.</p>
        <ul class="ind-feats">
          <li>Real-time home recommendations</li>
          <li>Virtual house visits with 360° views</li>
          <li>One-click site appointment scheduling</li>
        </ul>
      </a>
      <a class="ind-card" appReveal [routerLink]="['/industry-healthcare']">
        <div
          class="ind-icon"
          style="background: linear-gradient(135deg, #ff4d79, #ff85a1)"
        >
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
            <path
              d="M12 21s-7-4.5-9-9a4.5 4.5 0 019-1 4.5 4.5 0 019 1c-2 4.5-9 9-9 9z"
              stroke="#fff"
              stroke-width="1.6"
              stroke-linejoin="round"
            />
            <path
              d="M12 9v4M10 11h4"
              stroke="#fff"
              stroke-width="1.6"
              stroke-linecap="round"
            />
          </svg>
        </div>
        <h3>
          Healthcare
          <span class="arrow"
            ><svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <path
                d="M5 12h14M13 6l6 6-6 6"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              /></svg
          ></span>
        </h3>
        <p>
          Automate routine queries, improve patient experience, and gain
          real-time insights for clinical and operational decisions.
        </p>
        <ul class="ind-feats">
          <li>Automate patient support</li>
          <li>Boost patient satisfaction</li>
          <li>Seamless EHR integration</li>
        </ul>
      </a>
      <a class="ind-card" appReveal [routerLink]="['/industry-shopify-stores']">
        <div
          class="ind-icon"
          style="background: linear-gradient(135deg, #0fb94a, #5bd37f)"
        >
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
            <path
              d="M6 6h15l-1.5 9H7.5L6 6zM6 6L5 3H2M9 20a1 1 0 100 .01M18 20a1 1 0 100 .01"
              stroke="#fff"
              stroke-width="1.6"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <h3>
          Shopify Stores
          <span class="arrow"
            ><svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <path
                d="M5 12h14M13 6l6 6-6 6"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              /></svg
          ></span>
        </h3>
        <p>A 24/7 AI assistant for your online store.</p>
        <ul class="ind-feats">
          <li>Instant product Q&amp;A to boost confidence</li>
          <li>Real-time order tracking via chat</li>
          <li>Scheduling &amp; calendar integration</li>
          <li>Live agent handover for complex queries</li>
        </ul>
      </a>
    </div>
  </div>
</section>
